/* Endurance only. Section Store owns quantities, prices and cart selection. */
(() => {
  const config = document.getElementById('strive-endurance-variant-media');
  if (!config || config.dataset.bound) return;
  config.dataset.bound = 'true';
  const variants = JSON.parse(config.textContent);
  const boundBundles = new WeakSet();
  const boundPickers = new WeakSet();
  const lastChoices = new WeakMap();
  let lastBundleInteraction = -Infinity;
  // Section Store has no setting for a different selected button background per value.
  const colors = `
    .choice input[value="No Saborizada"]:checked + .button-label {
      background:#F1F2F0; border-color:#A4AAA0; color:#394135;
    }
    .choice input[value="Lima - Menta"]:checked + .button-label {
      background:#EDF6EC; border-color:#A4C39A; color:#385F32;
    }
    .choice .button-label {
      min-height:28px; padding:4px 10px; display:grid; align-items:center;
      border-radius:6px; font-size:13px; line-height:18px; font-weight:400;
    }
    .choice input:checked + .button-label { border-width:1px; font-weight:500; }
  `;

  function showMedia(bundle, title) {
    lastChoices.set(bundle, title);
    const variant = variants.find(item => item.title === title);
    if (!variant?.mediaId) return;
    const section = bundle.closest('[id^="MainProduct-"]');
    const gallery = section?.querySelector('media-gallery');
    const viewer = gallery?.querySelector('[id^="GalleryViewer-"]');
    const slides = Array.from(viewer?.querySelectorAll('[data-media-id]') || []);
    const target = slides.find(slide => slide.dataset.mediaId.endsWith(`-${variant.mediaId}`));
    if (!target) return;
    slides.forEach(slide => slide.classList.toggle('is-active', slide === target));
    const thumbnails = gallery.querySelector('[id^="GalleryThumbnails-"]');
    thumbnails?.querySelectorAll('[data-target] button').forEach(button => {
      if (button.closest('[data-target]').dataset.target === target.dataset.mediaId) {
        button.setAttribute('aria-current', 'true');
      } else button.removeAttribute('aria-current');
    });
    // Horizontal slider only: setActiveMedia also scrolls the entire page to the image.
    if (target.parentElement.scrollWidth > target.parentElement.clientWidth) {
      target.parentElement.scrollTo({ left:target.offsetLeft, behavior:'instant' });
    }
    const status = gallery.querySelector('[id^="GalleryStatus-"]');
    if (status) {
      status.setAttribute('aria-hidden', 'false');
      const message = `Imagen de Endurance ${title.toLowerCase()}`;
      if (status.textContent !== message) status.textContent = message;
    }
  }

  function bindPickers(bundle) {
    bundle.shadowRoot?.querySelectorAll('section-store--product-option-picker').forEach(picker => {
      const root = picker.shadowRoot;
      if (!root || boundPickers.has(picker)) return;
      boundPickers.add(picker);
      const style = document.createElement('style');
      style.dataset.striveEnduranceColors = 'true';
      style.textContent = colors;
      root.append(style);
      // Mark actual bundle interactions before the app's deferred native-radio click.
      for (const type of ['click', 'change']) root.addEventListener(type, event => {
        if (event.target.closest('.choice')) lastBundleInteraction = performance.now();
      }, true);
      root.addEventListener('change', event => {
        const input = event.target;
        if (input.matches('input[type="radio"]') && input.checked) showMedia(bundle, input.value);
      });
      // Clicking an already-selected color should also bring its image back.
      root.addEventListener('click', event => {
        const input = event.target.closest('.choice')?.querySelector('input[type="radio"]');
        if (input) queueMicrotask(() => { if (input.checked) showMedia(bundle, input.value); });
      });
    });
  }

  function bindBundles() {
    document.querySelectorAll('section-store--bundle-block').forEach(bundle => {
      if (!bundle.shadowRoot || boundBundles.has(bundle)) return;
      const product = JSON.parse(bundle.dataset.product || '{}');
      if (String(product.id).split('/').pop() !== '8882566398088') return;
      boundBundles.add(bundle);
      // Section Store clicks a native radio after a bundle choice. The theme then
      // updates its hidden variant ID/URL, which Section Store echoes to EVERY row.
      // Keep the app's own independent/cart selection and our media-only bridge;
      // cancel just that synthetic native click, never a shopper's native click.
      const section = bundle.closest('[id^="MainProduct-"]');
      section?.addEventListener('click', event => {
        if (event.isTrusted || performance.now() - lastBundleInteraction > 1000) return;
        if (!event.target.matches('variant-selects input[type="radio"]')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);
      // The theme fetches and replaces gallery media after its native variant
      // change. Reapply only the last requested photo after that replacement.
      const gallery = bundle.closest('[id^="MainProduct-"]')?.querySelector('media-gallery');
      if (gallery) {
        let frame;
        new MutationObserver(() => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            const title = lastChoices.get(bundle);
            if (title) showMedia(bundle, title);
          });
        }).observe(gallery, {childList:true, subtree:true});
      }
      bindPickers(bundle);
      new MutationObserver(() => bindPickers(bundle)).observe(bundle.shadowRoot, {childList:true, subtree:true});
    });
  }
  Promise.all([
    customElements.whenDefined('section-store--bundle-block'),
    customElements.whenDefined('section-store--product-option-picker')
  ]).then(bindBundles);
  document.addEventListener('shopify:section:load', bindBundles);
})();
